// TODO: Clean up and use webpack

// import test from './scroll.js'

// test()

// Make sure DOM is loaded
export default () => {

  // var menuOpen = document.getElementById('js-open-menu');
  // menuOpen.onclick = function() {
  //   var menuOverlay = document.getElementById('js-menu-overlay');
  //   document.body.classList.add('u-noscroll');
  //   menuOverlay.classList.add('c-navigation-overlay--visible');
  //   return false;
  // }

  var menuOpenMobile = document.getElementById('js-open-mobile-menu');
  menuOpenMobile.onclick = function() {
    var menuOverlay = document.getElementById('js-menu-overlay');
    document.body.classList.add('u-noscroll');
    menuOverlay.classList.add('c-navigation-overlay--visible');
    return false;
  }

  var closeOverlayItems = document.getElementsByClassName('js-close-overlay');
  for (var item = 0; item < closeOverlayItems.length; item++) {
    closeOverlayItems[item].onclick = function() {
      var menuOverlay = document.getElementById('js-menu-overlay');
      document.body.classList.remove('u-noscroll');
       menuOverlay.classList.remove('c-navigation-overlay--visible');
      window.location.assign = closeOverlayItems[item].href;
      return false;
    }
  }

  var closeOverlay = document.getElementById('js-close-overlay');
  closeOverlay.onclick = function() {
    var menuOverlay = document.getElementById('js-menu-overlay');
    document.body.classList.remove('u-noscroll');
    menuOverlay.classList.remove('c-navigation-overlay--visible');
    return false;
  }

  var last_known_scroll_position = 0;

window.addEventListener('scroll', function(event) {
  last_known_scroll_position = window.scrollY;
  var navigation_element = document.getElementById("js-navigation-bar");

  if (last_known_scroll_position > 30) {
    if (navigation_element.classList.contains('c-navigation-bar--minified')) {
    } else {
      navigation_element.classList.add('c-navigation-bar--minified');
    }
  } else {
    navigation_element.classList.remove('c-navigation-bar--minified');
  }

  return

});

}


